import Model from '../../ModelBinding/Model';
import AddressCollection from './AddressCollection';
import dayjs from 'dayjs';
import Member from '../Member/Member';

export default class Address extends Model {
  public city?: string;
  public city_en?: string;
  public country_code?: string;
  public state?: string;
  public street1?: string;
  public street2?: string;
  public zip_code?: string;
  public lat?: number;
  public lng?: number;
  public timezone?: string;
  public location_type?: string;
  public google_place_id?: string;
  public created_by?: Member;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.city = this.getStringAttribute('city');
    this.city_en = this.getStringAttribute('city_en');
    this.country_code = this.getStringAttribute('country_code');
    this.state = this.getStringAttribute('state');
    this.street1 = this.getStringAttribute('street1');
    this.street2 = this.getStringAttribute('street2');
    this.zip_code = this.getStringAttribute('zip_code');
    this.lat = this.getFloatAttribute('lat');
    this.lng = this.getFloatAttribute('lng');
    this.timezone = this.getStringAttribute('timezone');
    this.location_type = this.getStringAttribute('location_type');
    this.google_place_id = this.getStringAttribute('google_place_id');
    this.created_by = this.getRelationAttribute('created_by', Member) as Member;
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
  }

  static getCollection() {
    return AddressCollection;
  }

  get place() {
    return `${this.city}, ${this.country_code}`;
  }
  get placeEn() {
    if (this.city_en) {
      return `${this.city_en}, ${this.country_code}`;
    }
    return this.place;
  }
  get fullAddress() {
    return [
      this.street1 || '',
      this.street2 || '',
      `${this.zip_code || ''} ${this.city || ''}, ${this.country_code}`.trim(),
    ]
      .filter(comp => !!comp)
      .join(' ');
  }
}
